import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import { colorsFoundation } from "../../theme/tokens/colors-foundation.js";

const STATUS_LABELS = {
  pending: "Ausstehend",
  sent: "Gesendet",
  failed: "Fehlgeschlagen",
};

const STATUS_STYLES = {
  sent: {
    backgroundColor: colorsFoundation.label.green,
  },
  pending: {
    backgroundColor: colorsFoundation.label.orange,
  },
  failed: {
    backgroundColor: colorsFoundation.label.red,
  },
};

export default function OutgoingMailStatusChip({ status, sx = {} }) {
  const styles = STATUS_STYLES[status] ?? {
    backgroundColor: colorsFoundation.neutral[100],
    color: colorsFoundation.neutral[700],
  };

  return (
    <Chip
      label={STATUS_LABELS[status] ?? status}
      size="small"
      variant="outlined"
      sx={{
        ...sx,
        ...styles,
        borderColor: "transparent",
      }}
    />
  );
}

OutgoingMailStatusChip.propTypes = {
  status: PropTypes.oneOf(["sent", "pending", "failed"]),
};
